import { createTheme } from '@mui/material/styles'

import { DARK_GREY, LIGHT_GREY } from './theme'

// This separate theme is required for MUIDataTable to avoid affecting other MUITable elements
// MUITable styling seems to take precedence over MUIDataTable styling, so styles applied to .MuiDataTableCell-root for example, weren't being applied
const MuiDataTableTheme = createTheme({
  components: {
    MuiButtonBase: {
      styleOverrides: {
        root: {
          fontSize: '12px !important'
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          height: '24px',
          margin: '0px 8px',
          padding: 0,
          '&.Mui-checked': {
            color: LIGHT_GREY
          },
          '&.Mui-unchecked': {
            borderColor: 'rgba(0, 0, 0, 0.6)'
          }
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: '12px !important',
          '&:hover': {
            color: DARK_GREY
          }
        }
      }
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          maxWidth: '600px !important',
          width: '50% !important'
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '6px 15px !important',
          verticalAlign: 'top !important',
          whiteSpace: 'nowrap !important'
        }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiButtonBase-root': {
            fontSize: '14px !important',
            justifyContent: 'flex-start !important',
            marginLeft: '-8px',
            marginRight: '8px',
            minWidth: '0px',
            padding: '6px 8px',
            textTransform: 'none',
            width: '100%',
            '& .MuiTableSortLabel-root': {
              margin: '0px',
              padding: '0px'
            }
          }
        }
      }
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiTablePagination-select': {
            margin: '0 !important'
          },
          '& .MuiButtonBase-root': {
            height: '24px !important',
            padding: '0px 10px !important'
          }
        }
      }
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          paddingLeft: '15px !important',
          minHeight: 'initial !important',
          '& .MuiTablePagination-toolbar': {
            paddingLeft: '15px !important',
            paddingRight: '2px !important'
          }
        }
      }
    }
  }
})

export default MuiDataTableTheme
